import { FC } from "react";
import { useHistory } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

import { ReactComponent as LicenseIcon } from "components/ErrorFallback/500-license-plate.svg";
import "components/ErrorFallback/ErrorFallback.scss";

type Props = {
  error: Error;
  resetErrorBoundary: () => void;
};

export const ErrorFallback: FC<Props> = ({ resetErrorBoundary }) => {
  const history = useHistory();

  const navigate = () => {
    history.push("/");
  };

  return (
    <div className="ErrorFallback">
      <div className="ErrorFallback-overlay">
        <div className="ErrorFallback-container">
          <div className="ErrorFallback-action-buttons">
            <Button icon labelPosition="left" onClick={navigate}>
              <Icon className="arrow left" color="white" />
              Back to Homepage
            </Button>
            <Button color="light" onClick={resetErrorBoundary}>
              Reload page
            </Button>
          </div>
          <div className="NotFoundPage-car-repair">
            <div className="NotFoundPage-svg-icon">
              <LicenseIcon />
            </div>
            <div className="NotFoundPage-error-text">Internal Server Error</div>
          </div>
        </div>
      </div>
    </div>
  );
};
